{
    "Profile_Residents_CriminalConviction.criminalConviction": "Criminal Conviction",
    "Profile_Residents_CriminalConviction.criminalConvictionDetails": "Criminal Conviction Details",
    "Profile_Residents_CriminalConviction.dateOfConviction": "Date of Conviction",
    "Profile_Residents_CriminalConviction.convictionReason": "Conviction Reason"
}
